"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var extOverrides = exports.extOverrides = undefined;

exports.extOverrides = extOverrides = function extOverrides() {

    Ext.QuickTips.init();
};
//# sourceMappingURL=extOverrides.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/override/extOverrides.js
 ** module id = 156
 ** module chunks = 0 1
 **/